import { render, staticRenderFns } from "./TraxUiAjaxButton.vue?vue&type=template&id=487e283e"
import script from "./TraxUiAjaxButton.vue?vue&type=script&lang=js"
export * from "./TraxUiAjaxButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports